export const BLOG_CATEGORIES = [
  'SEO & Search',
  'Social Media Marketing',
  'Paid Advertising (PPC)',
  'Content Marketing',
  'Branding & Identity',
  'Website & Conversion Optimizations',
  'Email Marketing',
  'Analytics & Reporting',
  'Local Marketing',
  'Digital Marketing for Industries',
];
